import queryString from 'query-string';

import getCreditCardURL, { CC_URL_SLUGS } from './getCreditCardURL';


/**
 * Get the card-specific eligibility checker URL for CardFinder comparison against a given card.
 * @param {string} language - language code
 * @param {string} cardId - the card id
 * @param {string} productType - the card’s product type
 * @returns {string} - relative URL to the eligibility checker for a given card
 */
function getEligibilityCheckerURL(language, cardId, productType) {
    return queryString.stringifyUrl({
        url: getCreditCardURL(language, CC_URL_SLUGS.CARDFINDER_ELIGIBILITY_CHECKER),
        query: { cardId, productType },
    }, {
        skipNull: true,
        skipEmptyString: true,
    });
}

export default getEligibilityCheckerURL;
